export const GET_FEEDS = "GET_FEEDS";

export const GET_FEED = "GET_FEED";

export const GET_DASHBOARD_FEED = "GET_FEED";
